import { Component , NgZone} from '@angular/core';
import { IonicPage, NavController, LoadingController, NavParams, AlertController } from 'ionic-angular';
import { Sadhona } from '../../providers/sadhona'
/**
 * Generated class for the ViewMenteeSadhanaPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-view-mentee-sadhana',
  templateUrl: 'view-mentee-sadhana.html',
})
export class ViewMenteeSadhanaPage {
  dayArray:any=[]
  sadhonaDataArray:any
  myDate:any= new Date().getFullYear() + '-' + (new Date().getMonth() + 1)
  nofday:number;
  menteeuserid:number
  menteeusername:string
  activityname:any
  loading:any
  submitted = false;
  constructor(public navCtrl: NavController, public alertCtrl: AlertController, private zone: NgZone, public loadingCtrl: LoadingController, public navParams: NavParams, private sadhona:Sadhona) {
    this.menteeuserid = navParams.get("menteeuserid");
    this.menteeusername = navParams.get("menteeusername")
    this.activityname = navParams.get("activityname")
    this.getSadhonaSheet()
  }
  ionViewDidLoad() {
  }

  getMonthDate(){
    this.dayArray = []
    for(let i= 1; i <= this.nofday ; i++){ // n is array.length
      
      this.dayArray.push({day: i})
    }
  }

  getSadhonaSheet(){
    this.loading = this.loadingCtrl.create({
      content: 'Loading your records ',
      dismissOnPageChange: true
    });
    let daySplit = this.myDate.split('-')
    this.nofday = this.daysInMonth(daySplit[1], daySplit[0])
    let fromdate = this.myDate + '-01'
    let todate = this.myDate + '-' + this.nofday
    this.getMonthDate()
    this.getSubmittedSadhana();
    this.loading.present().then(()=>{
      this.sadhona.getMenteeSadhanaSheet(fromdate,todate, this.menteeuserid).subscribe(
        res => {
          this.zone.run(() => {
            this.sadhonaDataArray = res['data']
            setTimeout(() => {
              this.loading.dismiss();
            }, 500);
          });
        },
        err => {
          this.presentAlert('Error', 'something went wrong, try again')
          this.loading.dismiss();
        }
      )
    })  
  }

  daysInMonth (month, year) {
    return new Date(year, month, 0).getDate();
  }

  convertText(value){
    if(value == true){
      return 'checkbox-outline'
    }else if(value == false){
      return ''
    }else{
      return value
    }
  }

  presentAlert(title,msg) {
    let alert = this.alertCtrl.create({
      title: title,
      subTitle: msg,
      buttons: ['Dismiss']
    });
    alert.present();
  }

  getSubmittedSadhana() {
    this.submitted = false;
    const d = this.myDate.split('-')
    this.sadhona.getSubmittedApprovedSadhana(d[0], d[1], this.menteeuserid).subscribe(
      (res: any) => {
        if (res.data.length == 0) {
          this.submitted = false;
        } else {
          this.submitted = true;
        }
      }
    )
  }

}



// WEBPACK FOOTER //
// ./src/pages/view-mentee-sadhana/view-mentee-sadhana.ts